<mat-icon class="lease-icon" [svgIcon]="svgIconName" [matTooltip]="leaseRecordTypeDesc"></mat-icon>
